/* __next_internal_client_entry_do_not_use__ SVGIcon auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import isPropValid from "@emotion/is-prop-valid";
import { useUniqueId } from "@faire/web--source/ui/hooks/useUniqueId";
import { parseUnit } from "@faire/web--source/ui/lib";
import React from "react";
import styled, { css } from "styled-components";
import Color from "../Color";
import { HIGH_VIS_FILTER, highVisSlateComponent } from "../utils/highVisSlateComponent";
export var SVGIcon = function(_param) {
    var children = _param.children, className = _param.className, titleAccess = _param.titleAccess, width = _param.width, height = _param.height, margin = _param.margin, _param_viewBox = _param.viewBox, viewBox = _param_viewBox === void 0 ? "0 0 24 24" : _param_viewBox, Component = _param.component, ref = _param.ref, rest = _object_without_properties(_param, [
        "children",
        "className",
        "titleAccess",
        "width",
        "height",
        "margin",
        "viewBox",
        "component",
        "ref"
    ]);
    var labelId = useUniqueId("titleAccess-");
    return /*#__PURE__*/ _jsxs(StyledSvg, _object_spread_props(_object_spread({
        as: Component,
        ref: ref,
        className: className,
        focusable: "false",
        viewBox: viewBox,
        "aria-labelledby": titleAccess ? labelId : null,
        "aria-hidden": titleAccess ? null : "true",
        role: titleAccess ? "img" : "presentation",
        $margin: margin,
        // width/height exist in SVGIcon but we want to only pass as styles
        $width: width,
        $height: height
    }, rest), {
        children: [
            children,
            titleAccess ? /*#__PURE__*/ _jsx("title", {
                id: labelId,
                children: titleAccess
            }) : null
        ]
    }));
};
var generateSvgStyles = function(param) {
    var _param_$color = param.$color, $color = _param_$color === void 0 ? "inherit" : _param_$color, _param_$fill = param.$fill, $fill = _param_$fill === void 0 ? "currentColor" : _param_$fill, $fontSize = param.$fontSize, _param_$width = param.$width, $width = _param_$width === void 0 ? "1em" : _param_$width, _param_$height = param.$height, $height = _param_$height === void 0 ? "1em" : _param_$height, _param_$margin = param.$margin, $margin = _param_$margin === void 0 ? "0" : _param_$margin;
    if ($width === "" || $height === "") {
        // eslint-disable-next-line no-console
        console.error("Icon width/height can't be an empty string.");
    }
    var // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
    _Color_$color;
    return css([
        "display:inline-block;color:",
        ";fill:",
        ";flex-shrink:0;font-size:",
        ";width:",
        ";height:",
        ";margin:",
        ";transition:fill 200ms cubic-bezier(0.4,0,0.2,1) 0ms;user-select:none;"
    ], (_Color_$color = Color[$color]) !== null && _Color_$color !== void 0 ? _Color_$color : $color, $fill, $fontSize, parseUnit($width), parseUnit($height), $margin);
};
var StyledSvg = styled("svg").withConfig({
    shouldForwardProp: function(prop) {
        return isPropValid(prop);
    }
}).withConfig({
    componentId: "sc-713ba316-0"
})([
    "",
    " ",
    ""
], function(param) {
    var $margin = param.$margin, $height = param.$height, $width = param.$width, fill = param.fill, color = param.color, fontSize = param.fontSize;
    return generateSvgStyles({
        $margin: $margin,
        $width: $width,
        $height: $height,
        $fill: fill,
        $color: color,
        $fontSize: fontSize
    });
}, highVisSlateComponent(HIGH_VIS_FILTER.COMPONENT));
